import { ArrowCircleRightSharp, ArrowDropDown, ArrowDropUp, CheckCircleOutline, LocalConvenienceStoreOutlined } from "@mui/icons-material";
import { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { io } from 'socket.io-client';
import ConnUrls from "../../../Connections/ConnectURL";
import { CurrentPContext, MasterContext, OrderContext, UserContext } from "../../../ContextApi/context";
import BigPopUpMsg from "../../../DTechComp/BigPopUpMsg";
import PopUpMsg2 from "../../../DTechComp/PopUpMsg2";
import OrderConfirmation from "../../../DTechComp/Pops_Secials/OrderConfirmation/OrderConfirmation";

import MyDateTime from "../../../DTechComp/MyDateTime";
import No_Deliverys from "../../../DTechComp/Pop_Fixed/No_Deliverys";
import No_TakeAway from "../../../DTechComp/Pop_Fixed/No_TakeAway";
import Out_Of_Hours from "../../../DTechComp/Pop_Fixed/Out_Of_Hours";
import utilsOrders from "../../../_Utils/utilsOrders";
import utilsRests from "../../../_Utils/utilsRests";
import utilsUsers from "../../../_Utils/utilsUsers";
import ShowMyOrder from "./showMyOrder";
import ScrollingSaver from "../../../DTechComp/ScrollingSaver";
import { isFreshPageLoad } from "../../../DTechComp/NavigationTracker";
import PopUpMsg from "../../../DTechComp/PopUpMsg";
import TopBigSlides from "../../../DTechComp/TopBigSlides";
import OrderFunctions from "../../../OrderSettings/OrderFunctions";
import myFunctions from "../../../myFunctions";
import { Helmet } from "react-helmet";
import MyOrderDisp from "./MyOpenOrderDisp";
import MyOpenOrderDisp from "./MyOpenOrderDisp";
import MyClosedOrderDisp from "./MyClosedOrderDisp";
import MyFutureOrderDisp from "./MyFutureOrderDisp";
import { Button } from "@mui/material";
import GetTheAddress from "../../../OrderSettings/GetTheAddress";

const MyOrders = (props) => {




    const [master] = useContext(MasterContext);
    const [user] = useContext(UserContext);

    const [order, setOrder] = useContext(OrderContext);
    const [currentPage, setCurrentPage] = useContext(CurrentPContext);


    const [timers, setTimers] = useState([]);
    const [allOrders, setAllOrders] = useState([]);
    const [closed, setClosed] = useState([]);
    const [opens, setOpens] = useState([]);
    const [future, setFuture] = useState([]);
    const [maxCLosedToSHow, setMaxCLosedToSHow] = useState(10);
    const [firstHead, steFirstHead] = useState("מחפש הזמנות")
    const [ordersDataReady, setOrdersDataReady] = useState(false);

    const [thePopUp, setThePopUp] = useState("");

    const history = useHistory();

    // const [topSlides, setTopSlides] = useState();


    // socket ייעודי לעמוד - נפתח מחדש עם ה-token העדכני כשהמשתמש מזוהה.
    // בעבר ה-socket נוצר פעם אחת ברמת המודול עם localStorage.getItem("usrtoken")
    // שנקרא בזמן טעינת הקובץ; אם המשתמש התחבר אחרי - ה-socket נשאר בלי auth
    // והשרת לא שייך אותו ל-userId, כך ש-orderUpdated לא הגיע כלל.
    // התיקון לקרוא מ-localStorage לא הספיק: UserContextProvider (קומפוננטת-אב)
    // כותב את ה-token ל-localStorage ב-useEffect שתלוי גם הוא ב-user, ו-React
    // מריץ effects של ילד (MyOrders) לפני effects של הורה - כך שברינדור שבו
    // user מתעדכן לראשונה, הקריאה מ-localStorage כאן קדמה לכתיבה שם וקראה
    // token ישן/חסר. user.token קיים כבר על ה-user object עצמו - קריאה ישירה
    // ממנו לא תלויה בסדר ה-effects.
    useEffect(() => {
        if (user == null || user._id == null || user.token == null) return;

        const sock = io.connect(ConnUrls.socketClient, {
            auth: { token: user.token },
            query: { userType: "client" },
            forceNew: true
        });

        const handler = () => {
            getAndSetAllAOrders();
        };
        sock.on("orderUpdated", handler);

        return () => {
            sock.off("orderUpdated", handler);
            sock.disconnect();
        };
    }, [user])

    useEffect(() => {
        getAndSetAllAOrders();
    }, [])

    const getAndSetAllAOrders = async () => {

        if (user != null && user._id != null) {
            if (history.action !== "POP" || isFreshPageLoad()) props.scrollToTop();
            props.shoTopStrp(false)
            props.showfotter(true)
            props.setShowbanners(false)

            let getIt = await utilsUsers.getUsersOrders(user._id)

            if (!getIt.length > 0) { steFirstHead("לא נמצאו הזמנות") };

            setClosedOpens(getIt)
            setAllOrders(getIt);
            setOrdersDataReady(true);
        }
        else {
            history.push("./")
        }
    }

    // הטיימר וטקסט הסטטוס של כל הזמנה פתוחה מצוירים כעת ע"י MyOrderTimerCell
    // (רכיב memo עם setInterval משלו שקורא את ה-ord החי מה-props), במקום
    // interval מרכזי שתפס snapshot קפוא ודרס בכל שנייה את הסטטוס שה-render
    // של React הציג - מה שגרם לסטטוס לא להתעדכן בזמן אמת.

    let popTiming = -1;
    const duplicThisOrder = async (ordId) => {

        let ordtotdopSrc = await utilsOrders.getDuplictedOrder(ordId);
        let restPage = await utilsRests.getRestById(ordtotdopSrc.order.restId);

        let ordtotdop = ordtotdopSrc.order;
        if (ordtotdopSrc.missingItems && ordtotdopSrc.missingItems.length > 0) {
            let missItemsStr = ordtotdopSrc.missingItems.map(itm => itm.productName).join(", ");

            popTiming++;
            setThePopUp(
                <PopUpMsg key={popTiming}
                    nosnippet={true}
                    Title={["לא ניתן לשכפל את ההזמנה"]}
                    cssStyl={"okPOP"}
                    topSlides={<TopBigSlides
                        swiperCss={"spopImage"}
                        TopImages={[{ img: master.outOfStockImg, txt: "" }]} />}

                    ContentText={[{ txt: "הפריטים הבאים אינם זמינים כרגע בעסק:", css: "theTxtPop big rightText" },
                    { txt: `${missItemsStr}`, css: "theTxtPop regular bold rightText" },
                    { txt: "ולכן, לא ניתן לשכפל את ההזמנה", css: "theTxtPop big rightText" },
                    ]}
                    inLabel={""}
                    BtnTxt={"הבנתי, תודה"}
                    okClick={() => setThePopUp()}
                    btnClick2={() => history.push(`/restaurants/${ordtotdopSrc.restUrl}`)}
                    BtnTxt2={"צור הזמנה חדשה"}
                    btn1Css={"btnGreen bold btnPoppadding15"}
                    btn2Css={"btnYellow1 bold btnPoppadding15"}
                    errorMsg={""} />)
            return;
        }





        if (restPage === null) {
            <PopUpMsg key={popTiming}
                nosnippet={true}
                Title={["אופססס!!!"]}
                cssStyl={"okPOP"}
                topSlides={<TopBigSlides swiperCss={"spopImage"} TopImages={[{ img: master.oopsPopImg, txt: "" }]} />}
                ContentText={["עסק זה כרגע לא פעיל",
                    "להזמנות באתר"]}
                inLabel={""}
                BtnTxt={"חזור"}
                okClick={() => setThePopUp()}
                btn1Css={"btnGreen bold btnPoppadding15"}
                errorMsg={""} />

        }
        else {
            //מודע לשעות הערוץ, לא רק ל-Doing.
            //קודם הזמנה חוזרת של איסוף מחוץ לשעות האיסוף עברה בשקט,
            //כי לאיסוף לא היו שעות ושעות הפתיחה היו פתוחות
            const chans = MyDateTime.resolveBusinessChannels(restPage, master);
            let doDeliver = chans.deliveryOk;
            let doTakeAway = chans.takeAwayOk;

            //אין אף ערוץ שאפשר להזמין בו
            if (!chans.canOrderNow) {

                popTiming++;

                setThePopUp(
                    <Out_Of_Hours
                        okClick={() => { setThePopUp() }}
                        btn2Click={() => {
                            history.push(`/restaurants/${restPage.pageUrlFix != null &&
                                restPage.pageUrlFix != "" ? restPage.pageUrlFix : restPage._id
                                }`)
                        }}
                    />
                )


            }
            else {
                //לא מקבל משלוחים
                if (ordtotdop.OrderType === "Deliver") {
                    /* אין משלוחים בכלל */
                    if (!doDeliver) {
                        setThePopUp(
                            <No_Deliverys
                                okClick={() => setThePopUp(null)}
                                btnClick2={() =>
                                    history.push(
                                        `/restaurants/${restPage.pageUrlFix || restPage._id
                                        }`
                                    )
                                }
                            />
                        );
                        return;                       // ← מפסיק כאן
                    }

                    const itm = restPage.cityesToDeliver.find(
                        (ci) => ci.cityName === ordtotdop.deliveryAddress?.city
                    );

                    if (!itm) {

                        setThePopUp(
                            <GetTheAddress
                                restPage={restPage}
                                key={12}
                                theInsideComp="bgLGray"
                                allowBack={false}
                                GoTOPay={(newAddress) => handleAddressOK(ordtotdop, restPage, newAddress)}        // ← ממשיך אחרי אישור
                                closeMeFuc={() => setThePopUp(null)}
                                goBackToMenu={() => setThePopUp(null)}
                                shoTopStrp={() => { }}
                                scrollToTop={() => { }}
                            />
                        );
                        return;                       // ← מפסיק כאן
                    }
                }


                //לא מקבל Take
                if (ordtotdop.OrderType === "Take" && !doTakeAway) {
                    setThePopUp(
                        <No_TakeAway
                            okClick={() => setThePopUp(null)}
                            btnClick2={() =>
                                history.push(
                                    `/restaurants/${restPage.pageUrlFix || restPage._id}`
                                )
                            }
                        />
                    );
                    return;                         // ← מפסיק כאן
                }

                //הכל טוב, משכפל את הזמנה
                continueToMyOrder(ordtotdop, restPage);


            }
        }
    }

    const handleAddressOK = (ordtotdop, restPage, newAddress) => {
        setThePopUp(null);
        ordtotdop.deliveryAddress = newAddress;
        continueToMyOrder(ordtotdop, restPage);
    };

    const continueToMyOrder = (ordDup, restPage) => {
        setCurrentPage({ ...restPage, pageTYp: "withConPay" });
        setOrder(ordDup);
        history.push("/MyOrder");
    };

    const showThisOrder = (orderDivId) => {
        var ordDisp = window.document.getElementById(orderDivId);

        if (!ordDisp.classList.contains("showMe")) {
            ordDisp.classList.add("showMe");
            ordDisp.classList.remove("hideMe");

        } else {
            ordDisp.classList.add("hideMe");
            ordDisp.classList.remove("showMe");
        }
    }


    const orderConfirmd = (ord) => {
        // console.log(ord);
        setThePopUp(

            <OrderConfirmation
                isOpen={true}
                title="אישור קבלה"
                description="בלחיצה על אישור, נדע שקיבלת את ההזמנה"
                onConfirm={() => aprovedOrderRecive(ord)}
                onCancel={() => setThePopUp(null)}
                orderNumber={ord.orderNUM}
                amount={ord.totalPrice}
                currency={"₪"}
                orderType={ord.OrderType === "Take" ? "איסוף" : "משלוח"}
            />
            // <PopUpMsg2 key={popTiming}
            //     nosnippet={true}
            //     Title={["אישור קבלה"]}
            //     cssStyl={"okPOP centerPop mediumSizePop"}
            //     topSlides={<TopBigSlides TopImages={[{ img: master.orderApprovImg, txt: "" }]} />}
            //     ContentText={["בלחיצה על אישור", "נדע שקיבלת את ההזמנה", "וההזמנה תסגר"]}
            //     inLabel={""}
            //     okClick={() => aprovedOrderRecive(ord)}
            //     BtnTxt={"אישור"}
            //     btn1Css={"btnGreen bold btnPoppadding15"}
            //     btn2Css={"btnRed bold btnPoppadding15"}
            //     BtnTxt2={"חזור"}
            //     btnClick2={() => setThePopUp()}
            //     errorMsg={""} />
        )



    }


    const aprovedOrderRecive = async (ordr) => {

        await utilsOrders.updateStatus(ordr._id);
        setThePopUp();

        getAndSetAllAOrders();

    }

    const goToBack = () => {
        if (props.closePop) {
            props.closePop();
            return;
        }
        history.goBack();

    }

    myFunctions.useEscapeKey(props.closePop ? goToBack : null);

    const setClosedOpens = (OrdrsList) => {

        let open = []
        let close = []
        let futureOrds = []

        OrdrsList.forEach((ord, indx) => {

            let inord = ord.ord;

            if (inord.isFutureOrder && inord.orderStatus === "מתוזמן לעתיד") {

                futureOrds.push(ord)
            }
            else if (inord.orderStatus != "סגור" &&
                inord.orderStatus != "מושהה" &&
                inord.orderStatus != "מבוטל") {

                open.push(ord)
            }
            else {
                if (inord.orderStatus === "סגור" || inord.orderStatus === "מבוטל")
                    close.push(ord)
            }

        })

        futureOrds.sort((a, b) => new Date(a.ord.scheduledFor) - new Date(b.ord.scheduledFor));

        setOpens(open.reverse());
        setClosed(close.reverse());
        setFuture(futureOrds);

        return open;
    }

    const ShowAllCLosed = () => {
        setMaxCLosedToSHow(maxCLosedToSHow != Infinity ? Infinity : 10)
    }

    let countit = -1;

    return (
        <div className={"MyOrdersWrap"}>
            {!props.closePop &&
                <>
                    <div className={"headOnFixC2 centerText bold big"}>
                        ההזמנות שלי
                        <button type="button" className={`btnReset backSdOnlyBtn`} aria-label="חזור" onClick={() => goToBack()}>
                            <ArrowCircleRightSharp aria-hidden="true" />
                        </button>
                    </div>
                    <br /><br /><br /><br />
                </>
            }


            {/* <div className={"col-12 fullRow spaceRightLong overflowHid big bold"}>
                {(user?._id != null && user?.firstName != "null" && user?.firstName != "") &&
                    <span>{user.firstName}  {user?.lastName}</span>}

            </div> */}

            {(opens.length > 0) ?
                <>
                    <div className={"fullRow overflowHid"}>
                        <div className={"insideFrame"}>
                            {
                                opens.findIndex(ord => ord.ord.paymentStatus !== "ממתין לחיוב") !== -1 &&
                                <div div className={"spaceRightLong MbigFont bold SecondFont"}>הזמנות פעילות</div>
                            }

                            <div className={"MyOrdersLst"}>
                                <div className={"insideFrame"}>
                                    {
                                        opens.map((ord, indx) => {
                                            countit++;
                                            if (ord.ord.paymentStatus !== "ממתין לחיוב") {
                                                return (
                                                    <MyOpenOrderDisp key={indx} theOrder={ord}
                                                        ordrIndex={indx}
                                                        orderConfirmd={(ordBack) => orderConfirmd(ordBack)}
                                                        showThisOrder={(orderDivId) => showThisOrder(orderDivId)}
                                                    />
                                                )
                                            }
                                        })

                                    }
                                </div>
                            </div>
                        </div>

                    </div>
                </>
                : ""}
            {(future.length > 0) ?
                <>
                    <div className={"fullRow overflowHid maxWidth600"}>
                        <div className={"insideFrame"}>
                            <div className={"spaceRightLong MbigFont bold SecondFont"}>הזמנות עתידיות</div>

                            <div className={"ordAccordionList"}>
                                {
                                    future.map((ord, indx) => {
                                        countit++;
                                        return (
                                            <MyFutureOrderDisp key={indx} theOrder={ord}
                                                ordrIndex={indx}
                                            />
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>
                </>
                : ""}
            {
                (closed.length > 0) ? <>
                    <div className={"fullRow overflowHid maxWidth600"}>
                        <div className={"insideFrame"}>
                            <div className={"spaceRightLong big bold onRight"}>היסטוריית הזמנות</div>

                            <div className={"onLeft pointing"} >
                                <Button className={"myBtnWithIcon"} variant="outlined"
                                    startIcon={maxCLosedToSHow != Infinity ? <ArrowDropDown /> : <ArrowDropUp />}
                                    onClick={() => ShowAllCLosed()}
                                >
                                    <span className={"btnWithIconTxt"}>
                                        {maxCLosedToSHow != Infinity ? "הצג הכל" : "הצג אחרונים"}
                                    </span>
                                </Button>
                            </div>
                        </div>

                    </div>
                    <div className={"ordAccordionList maxWidth600"}>
                        {
                            closed.map((ord, indx) => {

                                countit++;
                                if (indx < maxCLosedToSHow) {
                                    return (
                                        <MyClosedOrderDisp theOrder={ord}
                                            key={indx}
                                            ordrIndex={indx}
                                            orderConfirmd={(ordBack) => orderConfirmd(ordBack)}
                                            duplicThisOrder={(ordId) => duplicThisOrder(ordId)}
                                        />
                                    )
                                }
                            })
                        }
                    </div>
                </>
                    : (opens.length === 0 && future.length === 0) && <h3> <center>{firstHead}</center></h3>
            }
            {!props.closePop && <ScrollingSaver pagNam={"MyOrders"} contentReady={ordersDataReady} />}
            {thePopUp}
            <Helmet
                meta={[
                    {
                        property: "og:url", content: `${ConnUrls.siteDomainNam}/MyOrders`
                    }
                ]}>
                <link rel="canonical" href={`${ConnUrls.siteDomainNam}/MyOrders`} />
            </Helmet>

        </div >
    )

}

export default MyOrders